<template>
	<section class="manifesto">
		<div class="manifesto-bg"></div>
		<div class="manifesto-scrim"></div>

		<div class="manifesto-content">
			<div class="title-wrap">
				<h1 class="manifesto-title">The Manifesto</h1>
			</div>
			<div class="title-rule"></div>

			<div class="litany">
				<p class="litany-line">Soliloquies of desire for more <b>lead me here...</b></p>
				<p class="litany-line">Lost perfection in scored moments <b>lead me here...</b></p>
				<p class="litany-line">Escapades fleeting my own freed wings <b>lead me here...</b></p>
				<p class="litany-line">Circling flights without fear of landing <b>lead me here...</b></p>
				<p class="litany-line">Degens of the same feather flocking together <b>lead us here...</b></p>
				<p class="litany-line">
					The world is our diners club &amp; the love of an angry bird <b>lead me here...</b>
				</p>
			</div>

			<div class="tagline">
				<img
					src="../assets/images/LOGO-ABDC-WHITE.png"
					alt="ABDC"
				/>
				<span
					>THE ANGRY BIRD DINERS CLUB <span class="sep">|</span> #ABDC
					<span class="sep">|</span> #THEDINERSCLUB <span class="sep">|</span> #WHATSONDAMENU</span
				>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'ManifestoPage',
};
</script>

<style scoped>
.manifesto {
	position: relative;
	width: 100%;
	min-height: 100vh;
	overflow: hidden;
	display: flex;
	align-items: center;
}
.manifesto-bg {
	position: absolute;
	inset: 0;
	background-image: url('../assets/images/BACKGROUND-MANIFESTO.png');
	background-size: cover;
	background-position: 65% center;
	filter: brightness(1.05) saturate(1.1);
}
.manifesto-scrim {
	position: absolute;
	inset: 0;
	background: linear-gradient(
		95deg,
		rgba(4, 4, 5, 0.94) 0%,
		rgba(4, 4, 5, 0.78) 34%,
		rgba(4, 4, 5, 0.35) 62%,
		rgba(4, 4, 5, 0.55) 100%
	);
	z-index: 1;
}
.manifesto-content {
	position: relative;
	z-index: 5;
	width: 100%;
	max-width: 1400px;
	margin: 0 auto;
	padding: 150px 48px 100px;
}

.title-wrap {
	overflow: hidden;
	margin-bottom: 8px;
}
.manifesto-title {
	font-family: 'Dead Revolution', 'Georgia', serif;
	font-size: clamp(2.4rem, 6.2vw, 4.6rem);
	letter-spacing: 0.02em;
	text-transform: uppercase;
	color: var(--ink);
	transform: translateY(110%);
	animation: reveal-up 1s cubic-bezier(0.16, 0.8, 0.24, 1) forwards;
	animation-delay: 0.1s;
}

@keyframes reveal-up {
	to {
		transform: translateY(0);
		opacity: 1;
	}
}

.title-rule {
	width: 64px;
	height: 2px;
	background: var(--blood-bright);
	margin: 22px 0 40px;
	transform: scaleX(0);
	transform-origin: left;
	animation: rule-grow 0.8s cubic-bezier(0.16, 0.8, 0.24, 1) forwards;
	animation-delay: 0.6s;
}
@keyframes rule-grow {
	to {
		transform: scaleX(1);
	}
}

.litany {
	max-width: 760px;
	border-left: 1px solid rgba(163, 32, 32, 0.35);
	padding-left: 28px;
}
.litany-line {
	font-family: 'JetBrains Mono', 'Courier New', monospace;
	font-size: clamp(0.92rem, 1.4vw, 1.15rem);
	line-height: 1.9;
	color: var(--ink-dim);
	font-weight: 400;
	opacity: 0;
	transform: translateY(14px);
	animation: line-reveal 0.8s cubic-bezier(0.16, 0.8, 0.24, 1) forwards;
}
.litany-line b {
	color: var(--ink);
	font-weight: 500;
}
.litany-line:nth-child(1) {
	animation-delay: 1s;
}
.litany-line:nth-child(2) {
	animation-delay: 1.25s;
}
.litany-line:nth-child(3) {
	animation-delay: 1.5s;
}
.litany-line:nth-child(4) {
	animation-delay: 1.75s;
}
.litany-line:nth-child(5) {
	animation-delay: 2s;
}
.litany-line:nth-child(6) {
	animation-delay: 2.3s;
	color: var(--ink);
	font-weight: 500;
	margin-top: 10px;
}
@keyframes line-reveal {
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.tagline {
	display: flex;
	align-items: center;
	gap: 14px;
	margin-top: 56px;
	opacity: 0;
	animation: line-reveal 1s ease forwards;
	animation-delay: 2.7s;
}
.tagline img {
	height: 22px;
	width: auto;
	opacity: 0.85;
}
.tagline span {
	font-family: 'JetBrains Mono', monospace;
	font-size: 12px;
	letter-spacing: 0.08em;
	color: var(--ink-dim);
	text-transform: uppercase;
}
.tagline .sep {
	color: var(--blood-bright);
	margin: 0 2px;
}

@media (max-width: 900px) {
	.manifesto-bg {
		background-position: 75% center;
	}
	.manifesto-scrim {
		background: linear-gradient(180deg, rgba(4, 4, 5, 0.55) 0%, rgba(4, 4, 5, 0.82) 45%, rgba(4, 4, 5, 0.95) 100%);
	}
	.manifesto-content {
		padding: 130px 24px 90px;
	}
	.litany {
		padding-left: 18px;
	}
	.litany-line {
		line-height: 1.75;
	}
}
</style>
